import { render, staticRenderFns } from "./TabBarItem.vue?vue&type=template&id=7522f6d3&scoped=true"
import script from "./TabBarItem.vue?vue&type=script&lang=js"
export * from "./TabBarItem.vue?vue&type=script&lang=js"
import style0 from "./TabBarItem.vue?vue&type=style&index=0&id=7522f6d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522f6d3",
  null
  
)

export default component.exports